import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  normalize,
  schema
} from "normalizr";
import {
  authorizedRequest,
  downloadXLSFile
} from "utils/api";
import {
  addNewNoteToAQuote,
  updateNoteOnAQuote
} from "utils/reducers";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const QUOTES_FETCH_REQUEST = "QUOTES_FETCH_REQUEST";
export const QUOTES_FETCH_SUCCESS = "QUOTES_FETCH_SUCCESS";
export const QUOTES_FETCH_FAILURE = "QUOTES_FETCH_FAILURE";

export const QUOTES_FETCH_SORT_REQUEST = "QUOTES_FETCH_SORT_REQUEST";
export const QUOTES_FETCH_SORT_SUCCESS = "QUOTES_FETCH_SORT_SUCCESS";
export const QUOTES_FETCH_SORT_FAILURE = "QUOTES_FETCH_SORT_FAILURE";

export const QUOTE_SINGLE_FETCH_REQUEST = "QUOTE_SINGLE_FETCH_REQUEST";
export const QUOTE_SINGLE_FETCH_SUCCESS = "QUOTE_SINGLE_FETCH_SUCCESS";
export const QUOTE_SINGLE_FETCH_FAILURE = "QUOTE_SINGLE_FETCH_FAILURE";

export const QUOTE_CREATE_REQUEST = "QUOTE_CREATE_REQUEST";
export const QUOTE_CREATE_SUCCESS = "QUOTE_CREATE_SUCCESS";
export const QUOTE_CREATE_FAILURE = "QUOTE_CREATE_FAILURE";

export const QUOTE_DELETE_REQUEST = "QUOTE_DELETE_REQUEST";
export const QUOTE_DELETE_FAILURE = "QUOTE_DELETE_FAILURE";

export const QUOTE_UPDATE_REQUEST = "QUOTE_UPDATE_REQUEST";
export const QUOTE_UPDATE_SUCCESS = "QUOTE_UPDATE_SUCCESS";
export const QUOTE_UPDATE_FAILURE = "QUOTE_UPDATE_FAILURE";

export const QUOTE_UPDATE_NEW_NOTE_SUCCESS = "QUOTE_UPDATE_NEW_NOTE_SUCCESS";
export const QUOTE_UPDATE_NOTE_SUCCESS = "QUOTE_UPDATE_NOTE_SUCCESS";

export const QUOTES_EXPORT_REQUEST = "QUOTES_EXPORT_REQUEST";
export const QUOTES_EXPORT_SUCCESS = "QUOTES_EXPORT_SUCCESS";
export const QUOTES_EXPORT_FAILURE = "QUOTES_EXPORT_SUCCESS";

export const QUOTE_KEY = "quotes";
export const QUOTE_ENTITY = new schema.Entity(QUOTE_KEY, {});
export const QUOTE_SCHEMA = [QUOTE_ENTITY];

const initialState = {
  quotes: []
};

export default function QuotesReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case QUOTES_FETCH_SUCCESS:
      return {
        ...state,
        ...payload.quotes,
        count: payload.count,
        page: payload.page,
        perPage: payload.perPage,
        order: payload.order
      };

    case QUOTES_FETCH_SORT_SUCCESS:
      return {
        ...state,
        ...payload.quotes,
        count: payload.count,
        page: payload.page,
        perPage: payload.perPage,
        order: payload.order
      };

    case QUOTE_UPDATE_SUCCESS:
      ToastSuccess("Save successful");

      return {
        ...state,
        quotes: {
          ...state.quotes,
          [payload.quote.id]: payload.quote
        }
      };

    case QUOTE_UPDATE_NEW_NOTE_SUCCESS:
      ToastSuccess("Save successful");

      return {
        count: state.count,
        page: state.page,
        perPage: state.perPage,
        order: state.order,
        quotes: addNewNoteToAQuote(state.quotes, action.quote.id, action.quote)
      };

    case QUOTE_UPDATE_NOTE_SUCCESS:
      ToastSuccess("Save successful");

      return {
        count: state.count,
        page: state.page,
        perPage: state.perPage,
        order: state.order,
        quotes: updateNoteOnAQuote(state.quotes, action.quote.id, action.quote)
      };

    case QUOTES_EXPORT_SUCCESS:
      return {
        ...state,
        quotesExport: payload
      };

    case QUOTES_EXPORT_FAILURE:
      return {
        succes: "error"
      };

    default:
      return state;
  }
}

/**
 * Get all quotes
 * @return {Object} Action
 */
export function fetchQuotes(payload) {
  return {
    type: QUOTES_FETCH_REQUEST,
    payload
  };
}

export function fetchQuotesSuccess(payload) {
  return {
    type: QUOTES_FETCH_SUCCESS,
    payload: {
      quotes: normalize(payload.quotes, QUOTE_SCHEMA).entities,
      count: payload.count,
      page: payload.page,
      perPage: payload.perPage,
      order: payload.quotes.map(quote => quote.id)
    }
  };
}

function fetchQuotesFailure(payload) {
  return {
    type: QUOTES_FETCH_FAILURE,
    payload
  };
}

/**
 * Get all quotes Sort
 * @return {Object} Action
 */
export function fetchQuotesSort(dealId, orderField, orderDir) {
  return {
    type: QUOTES_FETCH_SORT_REQUEST,
    payload: {
      dealId,
      orderField,
      orderDir
    }
  };
}

export function fetchQuotesSortSuccess(payload) {
  return {
    type: QUOTES_FETCH_SORT_SUCCESS,
    payload: {
      quotes: normalize(payload.quotes, QUOTE_SCHEMA).entities,
      count: payload.count,
      page: payload.page,
      perPage: payload.perPage,
      order: payload.quotes.map(quote => quote.id)
    }
  };
}

function fetchQuotesSortFailure(payload) {
  return {
    type: QUOTES_FETCH_SORT_FAILURE,
    payload
  };
}

/**
 * update Quote
 * @return {Object} Action
 */
export function updateQuote(payload, dealId, quoteId) {
  return {
    type: QUOTE_UPDATE_REQUEST,
    payload,
    dealId,
    quoteId
  };
}

export function updateQuoteSuccess(quote) {
  return {
    type: QUOTE_UPDATE_SUCCESS,
    payload: {
      quote
    }
  };
}

function updateQuoteFailure(payload) {
  return {
    type: QUOTE_UPDATE_FAILURE,
    payload
  };
}

/**
 * new Quote
 * @return {Object} Action
 */
export function createQuote(dealId) {
  return {
    type: QUOTE_CREATE_REQUEST,
    dealId
  };
}

export function createQuoteSuccess(payload) {
  return {
    type: QUOTE_CREATE_SUCCESS,
    payload: {
      quote: payload.quote,
      count: payload.count,
      page: payload.page,
      perPage: payload.perPage
    }
  };
}

function createQuoteFailure(payload) {
  return {
    type: QUOTE_CREATE_FAILURE,
    payload
  };
}

/**
 * create a Quote Notes
 * @return {Object} Action
 */

export function quoteNewNote(payload) {
  return {
    type: QUOTE_UPDATE_NEW_NOTE_SUCCESS,
    quote: payload.quote
  };
}

/**
 * update Quote Notes
 * @return {Object} Action
 */
export function quoteUpdateNote(payload) {
  return {
    type: QUOTE_UPDATE_NOTE_SUCCESS,
    quote: payload.quote
  };
}

/**
 * delete Quote
 * @return {Object} Action
 */
export function deleteQuote(quotes, dealId) {
  return {
    type: QUOTE_DELETE_REQUEST,
    quotes,
    dealId
  };
}

function deleteQuoteFailure(payload) {
  return {
    type: QUOTE_DELETE_FAILURE,
    payload
  };
}

/** export Quotes */
export function exportQuotes(payload) {
  return {
    type: QUOTES_EXPORT_REQUEST,
    payload
  };
}
export function exportQuotesSuccess(payload) {
  return {
    type: QUOTES_EXPORT_SUCCESS,
    payload
  };
}
export function exportQuotesFailure(error) {
  return {
    type: QUOTES_EXPORT_FAILURE,
    error
  };
}

// Saga
function* fetchSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.payload}/quotes`,
      "GET"
    );
    yield put(fetchQuotesSuccess(response));
  } catch (error) {
    yield put(fetchQuotesFailure(error));
  }
}

// /id/quotes/?orderField=recourse&orderDir=desc
function* fetchSortSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.payload.dealId}/quotes/?orderField=${
        payload.payload.orderField
      }&orderDir=${payload.payload.orderDir}`,
      "GET"
    );
    yield put(fetchQuotesSortSuccess(response));
  } catch (error) {
    yield put(fetchQuotesSortFailure(error));
    ToastError(`${error.message}(348)`);
  }
}

// Saga
function* updateSaga(payload) {
  try {
    const quote = {
      quote: payload.payload
    };
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.dealId}/quotes/${payload.quoteId}`,
      "PUT",
      quote
    );
    yield put(updateQuoteSuccess(response.quote));
  } catch (error) {
    yield put(updateQuoteFailure(error));
    ToastError(`${error.message}(367)`);
  }
}

// Saga
function* deleteSaga(payload) {
  try {
    yield call(authorizedRequest, "/quotes/archive", "PUT", {
      ids: payload.quotes
    });
    yield put(fetchQuotes(payload.dealId));
  } catch (error) {
    yield put(deleteQuoteFailure(error));
    ToastError(`${error.message}(380)`);
  }
}

// Saga
function* createSaga(payload) {
  const quoteModel = {
    quote: {
      lender: {
        name: "",
        type: ""
      },
      dealId: payload.dealId
    }
  };
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.dealId}/quotes`,
      "POST",
      quoteModel
    );
    yield put(fetchQuotes(response.quote.dealId));
  } catch (error) {
    yield put(createQuoteFailure(error));
    ToastError(`${error.message}(405)`);
  }
}

// Saga
function* exportSaga(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(
      downloadXLSFile,
      "/api/quotes/export",
      "POST",
      {
        ids: payload
      },
      "Quotes List"
    );
    yield put(exportQuotesSuccess(response));
  } catch (error) {
    yield put(exportQuotesFailure(error));
    ToastError(`${error.error}(426)`);
  }
}

export function* quotesSaga() {
  yield takeLatest(QUOTES_FETCH_REQUEST, fetchSaga);
  yield takeLatest(QUOTES_FETCH_SORT_REQUEST, fetchSortSaga);
  yield takeLatest(QUOTE_UPDATE_REQUEST, updateSaga);
  yield takeLatest(QUOTE_CREATE_REQUEST, createSaga);
  yield takeLatest(QUOTE_DELETE_REQUEST, deleteSaga);
  yield takeLatest(QUOTES_EXPORT_REQUEST, exportSaga);
}
